
import {typesStoredcarddet} from './svtypes/storedcarddet'


/*
//http://svabode-1420502022.us-west-1.elb.amazonaws.com/account/addressDetail
//POST http://localhost:8080/account/addressDetail
http://localhost:8086/account/addressDetail
rq
{
 "id":3
}



*/
let initStore = {
    loading: false,
    error: false,
    errob :{
        "timestamp": "2015-08-23T02:27:18.038+0000",
        "status": 500,
        "error": "Default Error",
        "message": "500 null",
        "path": "/kk/svaddressDetailPost"
    },
    crudsuccessob :{
        "timestamp": "2015-08-23T02:27:18.038+0000",
        "status": 200,
        "error": "Default Error",
        "message": "500 null",
        "path": "/kk/svaddressDetailPost"
    },
    my_data_geo:{
        "countryTypes": [
            {
                "name": "United STates America",
                "a2": "US",
                "a3": "USA",
                "value": "USA",
                "isonum": "840"
            },
            {
                "name": "Canada",
                "isdcode": "01",
                "a2": "CA",
                "a3": "CAN",
                "value": "CAN",
                "isonum": "124"
            }
        ],
        "stateTypes": [
            {
                "name": "California",
                "value": "CA",
                "a2": "CA"
            },
            {
                "name": "New York",
                "value": "NY",
                "a2": "NY"
            },
            {
                "name": "Texas",
                "value": "TX",
                "a2": "TX"
            }
        ],
        "isdcodeTypes": [
            {
                "name": "United States Of America(+1)",
                "value": "1"
            },
            {
                "name": "Australia(+61)",
                "value": "61"
            },
            {
                "name": "Spain(+34)",
                "value": "34"
            }
        ],
        "genderTypes": [
            {
                "name": "CL_MALE",
                "value": "MALE"
            },
            {
                "name": "CL_FEMALE",
                "value": "FEMALE"
            }
        ]
    },
    
    my_data_storedcard_confirmation:{

        "status":"OK",
        "cardId":5,
        "saveDate":"Jan 3027"
    },
    my_data_storedcarddet: {
    "id": -11,
    "cardId": -1,
    "customerId": 7,
    "paymentMethodCode": "",
    "paymentType": "",
    "productDetails": "",
    "description": "",
    "cardNumber": "",
    "cardCvv": "",
    "cardExpMonth": "",
    "cardExpYear": "",
    "email": "",
    "isValid": "",
    "cardDelete": "",
    "cardBlock": "",
    "createdDate": "",
    "modifiedDate": "",
    "createdBy": "",
    "modifiedBy": "",
    "name": "",
    "fname": "",
    "lname": "",
    "phone": "",
    "address": "",
    "zip": "",
    "isdcode": "",
    "city": "",
    "state": "",
    "country": ""
   

    },
    my_data_storedcarddet_svbak: {
        "id": -11,
        "cardId": 9,
        "customerId": 7,
        "paymentMethodCode": "card",
        "paymentType": "self",
        "productDetails": "svr",
        "description": "CHASE Card",
        "cardNumber": "4443412341234123",
        "cardCvv": "444",
        "cardExpMonth": "08",
        "cardExpYear": "22",
        "email": "alen@br.com",
        "isValid": "Y",
        "cardDelete": "N",
        "cardBlock": "N",
        "createdDate": "2024-08-13T04:00:00.000+0000",
        "modifiedDate": "2024-08-13T04:00:00.000+0000",
        "createdBy": "AbodeSystemAdmin",
        "modifiedBy": "AbodeSystemAdmin",
        "name": "",
        "fname": "",
        "lname": "",
        "phone": "",
        "address": "",
        "zip": "",
        "isdcode": "",
        "city": "",
        "state": "",
        "country": ""
    }
}

export default (state = initStore, action) => {
    console.log(action);
    let januState;
    switch (action.type) {
       
        case "GET_STOREDCARDDET_SUCCESS":
            console.log("reduce %%%%%%%%eJ31 my_data_geovsearcg  success*****************");
            console.log(action.payload.my_data_storedcarddet);
            // let januState = {...state, loading: false, my_data_storedcarddet: action.payload.my_data_storedcarddet}
             januState = {...state, loading: false,my_data_geo:action.payload.my_data_geo, my_data_storedcarddet: action.payload.my_data_storedcarddet, svr_soj_images: action.payload.my_images}
             console.log(januState)
            return januState
       
        case typesStoredcarddet.GET_STOREDCARDDET_BEGIN:
            console.log("loading")
            return {...state, loading: true}
        case typesStoredcarddet.GET_STOREDCARDDET_ERROR:
            console.log("error")
            console.log(action.payload.errob)
            const errjson = {
                "timestamp": "2024-08-23T02:27:18.038+0000",
                "status": 500,
                "error": "Internal Server Error",
                "message": "500 null",
                "path": "/accountclient/svaddressDetailPost"
            }
            return {...state,errob:action.payload.errob,crudsuccessob:null, error: true}
            case "RESET_STOREDCARD_INIT":
                let  my_data_storedcard_init = {
                 "id": -11,
                 "fname": "",
                 "lname": "",
                 "email": "",
                 "address": "",
                 "city": "Albany",
                 "state": "",
                 "zip": "",
                 "country": "",
                 "isdcode": "+1",
                 "phone": ""
             }
                 console.log("reduce %%%%%%%%RESET_SAVESTOREDCARD_INIT J31 my_data_geo  success*****************");
                    
                    if(action && action.payload && action.payload.my_data_geo){
                        januState = {...state, crud_flag:'I', error:false, loading:false, crudsuccessob:null,my_data_geo:action.payload.my_data_geo, my_data_storedcarddet:my_data_storedcard_init}
        
                    }else{
                        januState = {...state, crud_flag:'I', error:false, loading:false, crudsuccessob:null, my_data_storedcarddet:my_data_storedcard_init}

        
                    }
                    console.log(januState)
                    return januState
               
     
                case "GET_SAVESTOREDCARD_SUCCESS":
                        console.log("reduce %%%%%%%%evsearcg  success*****************");
                        console.log(action.payload.crudsuccessob);
                        // let januState = {...state, loading: false, my_data_addressdet: action.payload.my_data_addressdet}
                         januState = {...state,  error: true,loading: false, errob:null,crudsuccessob: action.payload.crudsuccessob}
                        return januState
                case "GET_SAVESTOREDCARD_BEGIN":
                            console.log("loading")
                            return {...state,loading: true}
                case "GET_SAVESTOREDCARD_ERROR":
                            console.log("crud error")
                            console.log(action.payload.errob)
                           
                            return {...state,errob:action.payload.errob,crudsuccessob:null, error: true}
        
        default:
            return state
    }
}